export default "__VITE_ASSET__YxlZXUaU__"